import React from 'react';
import {ContainerOuter, ResponseContainer, ResponseMessage} from './styles';

const Submitted = () => (
    <ContainerOuter>
        <ResponseContainer>
            <img src='/Assets/tick.png' alt={'Submitted Successfully'} />
            <ResponseMessage>Your request has been submitted successfully</ResponseMessage>
        </ResponseContainer>
    </ContainerOuter>
);

export default Submitted;